module.exports = __webpack_public_path__ + "static/media/customization-service.d3404ec9.svg";